// This file can be replaced during build by using the `fileReplacements` array.
// `ng build ---prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  endpoints: {
    // Local Assets
    form: 'assets/init/form.json',
    widget: 'assets/init/customWidgets.json',
    validatorsUrl: '/assets/init/validators.js',
    
    // validatorsUrl: '/assets/init/validators.js',
    // validatorsUrl: 'http://localhost:4200/assets/init/validators.js'    
    // healthcheck: 'assets/demo/hc.html',
    // healthcheck: 'http://localhost:4200/api/hc',

    // +----------------------------------------------------------------+
    // | PLEASE DON'T USE THIS TO COMPOSE THE URL TO CALL A SERVICE API |
    // | Use: Config.app.projectApiUrl as base URL instead              |
    // +----------------------------------------------------------------+    

    // Underwriting iSurvey Api
    // projectApiUrl: 'https://underwritingapit-internal-isurvey-forms.iso.com',
    // healthcheck: 'https://underwritingapit-internal-isurvey-forms.iso.com/hc',
    // fdcApiUrl: 'https://underwritingapit-internal-isurvey-forms.iso.com',
    // saveForm: 'https://underwritingapit-internal-isurvey-forms.iso.com/Form',
    // getForm: 'https://underwritingapit-internal-isurvey-forms.iso.com/Form',    
    // getForms: 'https://underwritingapit-internal-isurvey-forms.iso.com/Form/forms',    
    // getFormTypes: 'https://underwritingapit-internal-isurvey-forms.iso.com/FormType',
    // validatorsUrl: 'http://isurveyforms-controltowert.iso.com/assets/init/validators.js'
    // validatorsUrl: 'http://localhost:4200/assets/init/validators.js'    
    // getAllQuestion: 'https://underwritingapit-internal-isurvey-forms.iso.com/Questions/all',
    // getQuestion: 'https://underwritingapit-internal-isurvey-forms.iso.com/Questions',
    // getServiceCode:'https://underwritingapit-internal-isurvey-forms.iso.com/FlightDeck/services'
  }
};

/*
 * In development mode, to ignore zone related error stack frames such as
 * `zone.run`, `zoneDelegate.invokeTask` for easier debugging, you can
 * import the following file, but please comment it out in production mode
 * because it will have performance impact when throw error
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
